var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHotels = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Hotel--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Hotel Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.48 17h-19a0.5 0.5 0 0 0 -0.5 0.5V23a1 1 0 0 0 1 1H9a0.5 0.5 0 0 0 0.5 -0.5v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a0.5 0.5 0 0 0 0.5 0.5h6a1 1 0 0 0 1 -1v-5.5a0.5 0.5 0 0 0 -0.52 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.23 6.5h-0.36a0.51 0.51 0 0 1 -0.45 -0.28l-1.85 -3.67a1 1 0 0 0 -0.9 -0.55H19a0.5 0.5 0 0 1 -0.5 -0.5v-0.25A1.25 1.25 0 0 0 17.23 0h-2.5a1.25 1.25 0 0 0 -1.25 1.25v0.25A0.5 0.5 0 0 1 13 2h-2a0.5 0.5 0 0 1 -0.5 -0.5v-0.25A1.25 1.25 0 0 0 9.23 0h-2.5a1.25 1.25 0 0 0 -1.25 1.25v0.25A0.5 0.5 0 0 1 5 2h-0.71a1 1 0 0 0 -0.9 0.55L1.56 6.22a0.51 0.51 0 0 1 -0.45 0.28H0.77a0.75 0.75 0 1 0 0 1.5h22.46a0.75 0.75 0 0 0 0 -1.5ZM9 4.5a0.5 0.5 0 0 1 -0.5 0.5h-1a0.5 0.5 0 0 1 -0.5 -0.5V2a0.5 0.5 0 0 1 0.5 -0.5h1A0.5 0.5 0 0 1 9 2Zm8 0a0.5 0.5 0 0 1 -0.5 0.5h-1a0.5 0.5 0 0 1 -0.5 -0.5V2a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.48 9.5h-19A0.5 0.5 0 0 0 2 10v5a0.5 0.5 0 0 0 0.5 0.5h19a0.5 0.5 0 0 0 0.5 -0.5v-5a0.5 0.5 0 0 0 -0.52 -0.5Zm-13 4A0.5 0.5 0 0 1 8 14H6a0.5 0.5 0 0 1 -0.5 -0.5v-2A0.5 0.5 0 0 1 6 11h2a0.5 0.5 0 0 1 0.5 0.5Zm5 0a0.5 0.5 0 0 1 -0.5 0.5H11a0.5 0.5 0 0 1 -0.5 -0.5v-2a0.5 0.5 0 0 1 0.5 -0.5h2a0.5 0.5 0 0 1 0.5 0.5Zm5 0a0.5 0.5 0 0 1 -0.5 0.5H16a0.5 0.5 0 0 1 -0.5 -0.5v-2a0.5 0.5 0 0 1 0.5 -0.5h2a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHotels);
export default ForwardRef;